export const enUS = {
  productName: "Fastboot.js Next",
  tagline: "Android fastboot workstation in browser",
  navWorkspace: "Workspace",
  navSafety: "Safety",
  navDeploy: "Deploy",
  heroTitle: "Modern Web Fastboot Toolkit",
  heroSubtitle: "A browser-based WebUSB fastboot tool rebuilt as a public Material Design 3 website.",
  connect: "Connect device",
  disconnect: "Disconnect",
  github: "GitHub",
  safetyTitle: "High-risk operation notice",
  safetyText: "Flashing, unlocking, or writing partitions can cause data loss, boot failure, and warranty impact. Back up first, verify image sources, and do not run dangerous commands unless you understand the result.",
  browserNotice: "WebUSB is mainly supported by Chromium-based browsers. Boot the device into bootloader / fastboot mode.",
  device: "Device",
  notConnected: "Not connected",
  connecting: "Connecting",
  connected: "Connected",
  running: "Running",
  success: "Success",
  error: "Error",
  serial: "Serial",
  product: "Product",
  variant: "Variant",
  bootloader: "Bootloader",
  secure: "Secure",
  unlocked: "Unlocked",
  currentSlot: "Current slot",
  battery: "Battery / voltage",
  maxDownload: "Max download size",
  unknown: "Unknown",
  tasks: "Tasks",
  commandTab: "Command",
  bootTab: "Boot image",
  flashTab: "Flash partition",
  zipTab: "Flash ZIP",
  commandLabel: "Fastboot command",
  commandPlaceholder: "getvar:all",
  runCommand: "Run command",
  selectBootImage: "Choose boot.img",
  bootImage: "Boot image",
  partitionLabel: "Partition name",
  partitionPlaceholder: "boot",
  selectImage: "Choose image",
  flashPartition: "Flash partition",
  selectZip: "Choose factory image / update.zip",
  flashZip: "Flash ZIP",
  confirmDanger: "This operation may change boot state or write partitions. Continue?",
  progress: "Progress",
  idleProgress: "Waiting for task",
  logs: "Logs",
  clearLogs: "Clear",
  copyLogs: "Copy",
  copied: "Logs copied",
  deployTitle: "Static deployment",
  deployText: "The build output is static and works on GitHub Pages or Cloudflare Pages. GitHub Pages uses /Fastboot.js-Next/ as base; Cloudflare Pages can set VITE_BASE_PATH=/.",
  themeLight: "Light",
  themeDark: "Dark",
  themeSystem: "System",
  language: "Language",
  theme: "Theme",
  webusbUnavailable: "This browser does not support WebUSB.",
  mockMode: "No real device connected: the adapter keeps the android-fastboot integration path ready.",
  reconnectNeeded: "USB permission may be required again after device reboot.",
  noFile: "Choose a file first.",
  noPartition: "Enter a partition name.",
  emptyCommand: "Enter a fastboot command.",
  buildFor: "Supports GitHub Pages / Cloudflare Pages",
  relationship: "Built around the WebUSB capability and demo API from kdrag0n/fastboot.js."
} as const;
